import axios from 'axios'
import Vue from 'vue';
// import store from '../vuex/store'
// import util from '../common/js/util'
import {
    i18n
} from '@/until/vue-i18n';
import config from './config'
import Axios from "axios";
// const base = 'http://120.79.33.246:7001'
// const base = 'http://shop-test.stgolds.com:7001'
// const base = 'http://localhost:7002'
// const base = 'http://120.79.33.246:7001/'
// const base = 'http://192.168.6.215:7630'
// const base = 'http://192.168.10.168:7001'
// const base = 'http://192.168.10.149:7001'
const base = 'https://supbricks.com'
// const base = 'https://test.gobricks.cn'
// API地址在config里面
// const base = config.ADMIN_API
const _admin = '/supply/admin'
window.localStorage.setItem('base', base)
axios.defaults.withCredentials = false
axios.interceptors.request.use(config => {
    for (let key in config.data) {
        if (typeof config.data[key] === 'string') {
            config.data[key] = config.data[key] ? config.data[key].replace(/(^\s*) | (\s*$)/g, '') : '';
        }
    }
    // if (util.getCookie('csrfToken')) {
    //   config.headers['x-csrf-token'] = util.getCookie('csrfToken')
    // }
    return config
}, err => {
    return Promise.reject(err)
})

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
    return res
}, (error) => {
    // console.log(error)
    // console.log(error.response)
    const data = error.response.data;
    let tips = '';
    if (!data.to_method) {
        if (data.message) {
            tips = i18n.t(`msg.${data.message}`);
            if (data.add_msg) {
                for (const key in data.add_msg) {
                    tips = tips.replace(new RegExp(`{${key}}`, 'g'), data.add_msg[key]);
                }
            }
        } else {
            tips = data;
        }
        // let tips = i18n.t(`msg.${data.message}`);
        // store.dispatch('SHOWMSG', `HTTP代码:${error.response.status},提示:${tips}`)
    }

    return Promise.reject(error)
})
axios.defaults.baseURL = base + _admin;
Vue.prototype.$http = axios;
export default axios;

export const getMyRole = params => {
    return axios.get(`/role/myRole`, {params})
}

export const getAdminRoles = params => {
    return axios.get(`/role/list`, {params})
}

export const getAdminUserList = params => {
    return axios.get(`/companyUser/list`, {params})
}

//公司首页配置详情 请求方式post
export const getHomeDetail = () => {
    return axios.post(`/companyIndexConfig/detail`)
}

//修改公司首页配置详情  请求方式post
export const updateHomeConfig = (params) => {
    return axios.post(`/companyIndexConfig/update`, params)
}

//修改公司首页配置详情  请求方式post
export const getFactoryList = (params) => {
  return axios.get(`/produceFactory/list`, {params})
}
export const getKuaidi = params => { // 获取快递公司列表
    return axios.get(`/kuaidi100/listExpressForLabelOrder`, params);
}
export const labelOrder = params => { // 生成快递单
    return axios.post(`kuaidi100/labelOrder`, params);
}
export const setHasPrint = params => { // 设置已打印
    return axios.post(`kuaidi100/order/setHasPrint`, params);
}
export const labelOrderBatch = params => { // 电子面单批量下单
    return axios.post(`kuaidi100/labelOrderBatch`, params);
}



// WEBPACK FOOTER //
// ./src/api/api.js